import React, { useEffect } from "react";
import { connect } from "react-redux";
function OtpInputBox(props) {
  /**
   *
   * @param value(string)
   * @returns void
   */
  const onChangeHandle = (value) => {
    if (value.length > props.maxlength) return;

    props.onChange(value);
  };

  return (
    <>
      <div class="otp-input">
        <input
          id={props.htmlId}
          value={props.value}
          onChange={(event) => {
            onChangeHandle(String(event.target.value));
          }}
          type="number"
          inputMode="numeric"
          autoComplete={props.allowAutoFill ? "one-time-code" : undefined}
          disabled={props.disabled}
        />
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {};
};
export default connect(mapStateToProps, {})(OtpInputBox);
